'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'icons';
var width = 512;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = 'M73.3 0c19.5 0 38.5 7.7 52.3 21.5L114.2 32.9C103.5 22.1 88.6 16 73.3 16C41.8 16 16 41.5 16 72.6c0 15.6 6.5 30.6 17.9 41.3L128 202.1l94.1-88.2C233.5 103.1 240 88.2 240 72.6c0-31-25.8-56.6-57.3-56.6c-15.3 0-30.2 6.1-41 16.9l-2.5 2.5L128 46.6 116.7 35.3l-2.5-2.5 11.3-11.3L128 24l2.5-2.5C144.3 7.7 163.2 0 182.7 0C222.8 0 256 32.5 256 72.6c0 20.1-8.3 39.2-22.9 52.9L128 224 22.9 125.5C8.3 111.8 0 92.6 0 72.6C0 32.5 33.2 0 73.3 0zM512 6.2l0 9.8 0 160s0 0 0 0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.3l0-118.5L352 54.6 352 208s0 0 0 0c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c19.1 0 36.3 6.3 48 16.3L336 48l0-6.6 6.4-1.3 160-32L512 6.2zM483.7 154.9c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1c0 0 0 0 0 0c0-7.1-3.8-14.7-12.3-21.1zm-160 32c-8.6-6.4-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1s3.8 14.7 12.3 21.1s21.1 10.9 35.7 10.9s27.1-4.4 35.7-10.9s12.3-14.1 12.3-21.1c0 0 0 0 0 0c0-7.1-3.8-14.7-12.3-21.1zM472 256l8 0 11.4 0-3.8 10.7L451.4 368l52.6 0 8 0 0 8 0 16 0 3.9-3.1 2.4-144 112-2.2 1.7-2.7 0-8 0-11.4 0 3.8-10.7L380.6 400 328 400l-8 0 0-8 0-15.1 0-3.9 3.1-2.4 144-112.9 2.2-1.7 2.8 0zM336 380.8l0 3.2 56 0 11.4 0-3.8 10.7-33.8 94.7L496 388.1l0-4.1-56 0-11.4 0 3.8-10.7 33.8-94.7L336 380.8zM200 272l16 32 56 0 16 0 0 16 0 176 0 16-16 0L16 512 0 512l0-16L0 320l0-16 16 0 56 0 16-32 112 0zm16 48l-9.9 0-4.4-8.8L190.1 288l-92.2 0L86.3 311.2 81.9 320 72 320l-56 0 0 176 256 0 0-176-56 0zm-32 88a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;